module.exports = __webpack_public_path__ + "static/Resume-addff1f82a569ae1b6a870641c7f69cc.pdf";